module.exports = __webpack_public_path__ + "img/bb_m_4_fr.59d91f47.jpg";